import { useEffect, useState } from 'react';
import { useGetCurrencies } from 'api/invoices';
import { CurrencyQueryParams } from 'api/invoices/invoices.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { CurrencyCode } from 'pages/invoices/invoices.types';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';
import { CURRENCY_LABEL } from 'pages/rates/components/RatesForm/RatesForm.consts';

export default function CurrencyAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({
  formProps,
  error,

  onCurrencyChange,
}: {
  formProps: TFieldValues;
  error: boolean;
  index: number;
  onCurrencyChange: any;
}) {
  const { currenciesData, loading, getCurrencies } = useGetCurrencies();
  const [options, setOptions] = useState<CurrencyCode[]>([]);
  const [currencyParams, setCurrencyParams] = useState<CurrencyQueryParams>({
    filterText: '',
    pageNumber: 1,
    onlyVisible: true,
  });

  useEffect(() => {
    getCurrencies(currencyParams);
  }, [getCurrencies, currencyParams]);

  useEffect(() => {
    if (currenciesData?.length) {
      const fetchedOptions = currenciesData.map((currency) => ({
        id: currency.id,
        lock: currency.lock,
        enabled: currency.enabled,
        currency: currency.currency,
        visible: currency.visible,
      }));
      const filteredOptions = fetchedOptions.filter(
        (activity) => activity.enabled,
      );
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [currenciesData]);

  return (
    <AutocompletePaginationAsync
      label={CURRENCY_LABEL}
      {...formProps}
      padding='dense'
      width={160}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      handleSearchChange={handleChange(setOptions, setCurrencyParams)}
      getOptionLabel={(o) => o.currency}
      onChange={(_, data) => {
        formProps.field.onChange(data);
        if (data) {
          onCurrencyChange(data);
        }
      }}
      onScrollBottom={() =>
        setCurrencyParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setCurrencyParams,
        formProps.field.onBlur,
      )}
    />
  );
}
